/**
 * Utilitário robusto para copiar texto para a área de transferência em qualquer ambiente:
 * HTTPS, HTTP (ex: customer.sstlocal, contexto não seguro), Mobile iOS/Android, Desktop.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false;

  // 1. Tenta a API nativa navigator.clipboard se disponível e em contexto seguro
  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn('navigator.clipboard.writeText falhou, acionando fallback:', err);
    }
  }

  // 2. Fallback universal usando textarea temporário
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    // Mantém no DOM e selecionável, mas sem alterar layout visual
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.setAttribute('readonly', '');

    document.body.appendChild(textArea);
    textArea.focus({ preventScroll: true });
    textArea.select();
    textArea.setSelectionRange(0, text.length);

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      return true;
    }
  } catch (err) {
    console.error('execCommand copy falhou:', err);
  }

  // 3. Fallback de prompt interativo se a segurança do navegador bloquear execCommand
  try {
    window.prompt('Copie o link abaixo:', text);
    return true;
  } catch {
    return false;
  }
}
